import { render, staticRenderFns } from "./ExpiredBalanceDialog.vue?vue&type=template&id=001c96e0"
import script from "./ExpiredBalanceDialog.vue?vue&type=script&lang=js"
export * from "./ExpiredBalanceDialog.vue?vue&type=script&lang=js"
import style0 from "./ExpiredBalanceDialog.vue?vue&type=style&index=0&id=001c96e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports